
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.487 1.467A5.015 5.015 0 0016.925 0a5.12 5.12 0 00-3.601 1.467l-2.359 2.265-2.358-2.264A5.069 5.069 0 003.112.383 5.037 5.037 0 00.85 2.23a4.996 4.996 0 000 5.572A5.037 5.037 0 003.112 9.65a5.068 5.068 0 005.495-1.085l2.358-2.337 2.359 2.337a5.056 5.056 0 003.583 1.518 5.08 5.08 0 003.605-1.465A5.025 5.025 0 0022 5.038a5.005 5.005 0 00-1.513-3.57zM7.312 7.28a3.256 3.256 0 01-4.572 0 3.199 3.199 0 01.029-4.517 3.235 3.235 0 014.542-.01L9.59 5.007 7.312 7.28zm11.879 0a3.254 3.254 0 01-4.57 0l-2.28-2.27 2.28-2.259a3.256 3.256 0 014.57 0 3.197 3.197 0 01.945 2.264 3.182 3.182 0 01-.945 2.264z","fill":"#525C7A"}})])
          )
        }
      }
    